export default "__VITE_ASSET__DmOhngZb__"